export const GRAPHQL_VARIABLES = {};

export const QUERY = `
 mutation createMicrosite {
   createMicrosite {
       link
   }
 }
 `;
